import { DatabaseType } from '../types/database'

export const SUPPORTED_DATABASE_TYPES: DatabaseType[] = ['sqlite', 'csv', 'tsv', 'json', 'access', 'postgresql']

export const DATABASE_TYPE_LABELS: Record<DatabaseType, string> = {
  sqlite: 'SQLite Database',
  csv: 'CSV File',
  tsv: 'TSV File',
  json: 'JSON File',
  access: 'Microsoft Access Database',
  postgresql: 'PostgreSQL Database'
}

export const MAX_FILE_SIZE = 100 * 1024 * 1024 // 100MB

export const DEFAULT_PAGE_SIZE = 50

export const SEARCH_DEBOUNCE_DELAY = 300 // milliseconds 